export default "__VITE_ASSET__0c7d6f79__"